"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    init() {
        // JavaScript to be fired on the about us page
    },
};
